


































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Table } from "../../viewmodels/Table";
import { LayoutViewModel } from "../../viewmodels/LayoutViewModel";

@Component({})
export default class extends Vue {
    public collection = app.tableCollection;
    public categoryCollection = app.categoryCollection;

    public search: string = "";
    public model: Table = new Table({}, this.collection);
    public selectedModel: Table | null = null;

    public layoutViewModel: LayoutViewModel = new LayoutViewModel(this.collection);

    public result = "";

    public dialog = false;
    public formTitle: string = "Restaurant";

    public headers = [
        { text: "Name", value: "name" },
        { text: "Seats", value: "number_of_seats" },
        { text: "Layout Pos", value: "layout_x" },
        { text: "Actions", value: "" }
    ];

    public selectModel(model: any, event: any) {
        this.selectedModel = model;
    }

    public mouseMove(event: any) {
        if (this.selectedModel) {

            const layout = this.$refs.layout as HTMLElement;

            const width = layout.clientWidth;
            const height = layout.clientHeight;

            this.layoutViewModel.width = width;

            this.selectedModel.layout_x = Math.round((event.offsetX / width) * 100);
            this.selectedModel.layout_y = Math.round((event.offsetY / height) * 100);
        }
    }

    public get backgroundStyle() {
        return {
            "border": '2px solid #ddd',
            "height": `${this.layoutViewModel.height}px`,
            "background-image": `url(${this.layoutViewModel.sourceUrl})`,
            "background-size": "cover"
        };
    }

    public async mounted() {
        this.search = this.collection.search;
        this.collection.refreshData();
        window.addEventListener("resize", this.onWindowResize);
        this.onWindowResize();

        try {
            const layoutModel = await app.layoutService.getLayoutImage();

            if (layoutModel) {
                this.layoutViewModel.sourceWidth = layoutModel.width;
                this.layoutViewModel.sourceHeight = layoutModel.height;
                this.layoutViewModel.sourceUrl = layoutModel.url;
            }
        } catch (e) { console.log(e) };
    }

    public beforeDestroy() {
        window.removeEventListener("resize", this.onWindowResize);
    }

    private onWindowResize() {
        const layout = this.$refs.layout as HTMLElement;
        if (layout) {
            const width = layout.clientWidth;
            const height = layout.clientHeight;
            this.layoutViewModel.width = width;
        }
    }

    @Watch("search")
    public onSearchChange() {
        this.collection.doSearch(this.search);
    }

    public remove(model: any) {
        const dialog: any = (this.$root as any).$confirm;

        dialog("Delete", "Are you sure?").then((confirm: boolean) => {
            if (confirm) {
                model.delete();
            }
        });
    }

    public close() {
        this.dialog = false;
    }

    public async save() {
        try {
            await this.model.save();
            this.dialog = false;
            this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
        } catch (e) {
            this.$store.dispatch("showSnackbar", {
                message: "Whoops, error while saving data!"
            });
        }
    }

    public saveLayout() {

        for (let model of this.collection.models) {
            model.save();
        }
    }

    public add() {
        this.model = new Table({}, this.collection);
        this.dialog = true;
    }

    public edit(item: Table) {
        this.model = item;
        this.dialog = true;
    }

    private async onFileSelect(file: any) {
        if (file) {
            const response = await app.uploadService.upload(file, "/tables/upload");
            this.$store.dispatch("showSnackbar", {
                message: "Image uploaded succesfully!"
            });
            app.refreshData();
        }
    }
}
